import ApiHelper from '@/utils/api-helper'
import API from '@/constants/api'

/**
 * Company service class containing all methods to retrieve companies
 */
class CompanyService {
  static getCompanies(limit = 10, page = 1, filter = '') {
    return ApiHelper.fetch(
      `${API.URL + API.COMPANIES}?pageSize=${limit}&page=${page}&filter=${filter}`
    )
  }

  static getCompany(id) {
    return ApiHelper.fetch(`${API.URL + API.COMPANIES}/${id}`)
  }

  static updateCompany(company) {
    if (typeof company._id === 'undefined') {
      return this.addCompany(company)
    }

    return ApiHelper.fetch(`${API.URL + API.COMPANIES}/${company['_id']}`, {
      method: 'PUT',
      body: JSON.stringify({
        company
      })
    })
  }

  static addCompany(company) {
    return ApiHelper.fetch(`${API.URL + API.COMPANIES}`, {
      method: 'POST',
      body: JSON.stringify({
        company
      })
    })
  }

  static deleteCompany(id) {
    return ApiHelper.fetch(`${API.URL + API.COMPANIES}/${id}`, {
      method: 'DELETE'
    })
  }
}

export default CompanyService
